import { Fragment, lazy, useEffect, useState } from "react";

import { ElementGroup, LeftTableContainer, TableContainer, Title } from "styles/components";
import styled from "styled-components";
import TabMenu from "components/ui/TabMenu";
import { UiDateOptionGroup } from "components/ui/DateOptionGroup";
import { UiSelectBox } from "components/ui/SelectBox";
import { UiType } from "commons/ui/uiVo";
import { useDispatch } from "react-redux";

import Grid from "commons/ui/grid/Grid";
import type { IGridSetting, IGrideCell } from "commons/ui/grid/GridVo";
import { GridLocalStringCell } from "components/grid/GridCell";
import { GridLeftTextCell } from "commons/ui/grid/AbsGridCell";
import GridEmpty from "components/grid/GridEmpty";
import Pagelable from "components/ui/Pagelable";
import { useUiAction } from "commons/ui/reUi/useUihook";
import { useSetRadio } from "commons/ui/useUihook";
import { Grade } from "store/modules/auth/authVo";
import useAuth from "store/modules/auth/authHook";
import { ButtonColor, ButtonSize } from "components/ComponentsType";
import Button from "components/ui/Button";
import { useCSVUploadPopup } from "components/popup/insight/CSVUploadHook";
import Spinner from "components/ui/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import { rdxSetActiveTab } from "pages/service/store/ServiceR";
import type { ServiceActiveTab } from "pages/service/store/ServiceVo";
import { numberComma } from "pages/calculate/components/manage";
import {
  useContentGridListLoad,
  useDateGridListLoad,
  useIniteDateOption,
  useStatisticsContentsGrid,
  useStatisticsDateGrid,
} from "pages/statistics/store/StatisticsHook";
import type {
  IStatisticsContentsGridVo,
  IStatisticsDateGridVo,
  StatisticsTabType,
} from "pages/statistics/store/StatisticsVo";
import { LazyChart } from "pages/provider";
import { useSelectorEq } from "commons/store/common";
import type { IState } from "store/modules";

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;

  > div {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const TabContainer = styled(ElementGroup.Row)`
  width: 100%;
  li {
    margin-left: 10px;
    button {
      border: none;
      width: 120px;
      height: 44px;
      border-radius: 100px;
      background: #f0f0f0;
      color: #000;
      font-weight: 500;
      &.is-active {
        color: #fff;
        background-color: var(--primary);
        font-weight: 500;
      }
      span {
        display: none;
      }
    }
  }
`;
const ContentsGridContainer = styled.div<{ isLoading: boolean }>`
  border-radius: 8px;
  border: 1px solid var(--border-normal);
  width: 100%;
  padding: 25px 10px 15px;
  height: auto;
  margin-top: 30px;
  position: relative;

  h3 {
    padding: 0 20px;
    font-size: 1.1rem;
    color: #161c1c;
    margin-bottom: 20px;
  }
  .grid-wrapper {
    /* ${props =>
      props.isLoading
        ? `
      filter: blur(2px);
      -webkit-filter: blur(2px);
        `
        : ""} */
    ${props =>
      props.isLoading
        ? `
          tbody * {color:#c7c7c7;}
        `
        : ""}

    table {
      width: 100%;
      position: relative;
      * {
        font-size: 1rem;
      }
      thead {
        th {
          background-color: #fff;
          color: #7c8484;
          font-weight: 600;
          border-bottom: 1px solid var(--border-normal);
          &:first-child {
            /* width: 60%; */
            text-align: left;
          }
          &:last-child {
            /* width: 20%; */
          }
        }
      }
      tbody {
        tr {
          border-bottom: 1px solid var(--border-normal);
          &:last-child {
            border: none;
          }
        }
        td {
          height: 52px;
          color: #444;
          font-weight: 300;
        }
      }
    }
  }

  .contents-grid-wrap {
    tbody td {
      padding: 10px 20px;
    }
  }
`;
const ElementRroupWrap = styled(ElementGroup.Row)`
  margin: 24px 0 6px 0;
`;

const OptionContainer = styled(ElementGroup.Col)`
  width: 100%;
  align-items: baseline;
  > div:first-child {
    .channel-select-items div {
      background-color: var(--primary);
      font-size: 0.95rem;
      margin-right: 3px;
    }
  }
`;

const DateOptionWrap = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;

  input {
    &:checked + label {
      border-radius: 8px;
      border: 1px solid #05bcc6;
      background: #05bcc6;
      font-weight: 500;
    }
    & + label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 38px;
      border-radius: 8px;
      border: 1px solid var(--border-normal);
      color: #444;
      text-align: center;
      font-size: 1rem;
      letter-spacing: -0.14px;
    }
  }

  .upload-btn-wrap button {
    font-size: 0.97rem;
    border: 1px solid var(--border-normal);
    padding: 10px 16px;
    line-height: normal;
  }
`;

const ServiceGuideWrapper = styled.div`
  width: 80%;
  min-width: 960px;
  max-width: 1280px;
  min-height: 940px;
  margin: 0 auto;
  position: relative;
  > div {
    width: 100%;

    justify-content: space-between;
  }
  .guide-title-conainer {
    width: 100%;
    margin: 40px 0;
    position: relative;
    p {
      position: relative;
      color: #222;
      font-size: 2rem;
      font-weight: 500;
      line-height: 35px;
      &:first-child {
        font-weight: 700;
        font-size: 2.8rem;
        margin-bottom: 20px;
        &:after {
          content: "";
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 65%;
          height: 52%;
          background: linear-gradient(45deg, #a4dfe9, #e2e6ff, transparent 65%);
          z-index: -1;
        }
      }
      &.sub {
        color: #585858;
        font-size: 1.3rem;
        font-weight: 400;
      }
    }
  }
  .guide-btn-wrapper {
    width: 100%;
    display: flex;
    margin: 70px 0px;
    justify-content: center;
    button {
      width: 360px;
      height: 70px;
      text-align: center;
      font-size: 1.3rem;
      border-radius: 50px;
      font-weight: 500;
    }
  }
  .guide-footer {
    width: 100%;
    margin-top: 20px;
    padding: 80px 0;
    > p {
      color: #222;
      font-size: 1.2rem;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .guide-step-wrapper {
      width: 100%;
      .service-process-list {
        display: flex;
        width: 100%;
        gap: 40px;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        padding-top: 30px;
        background: url("https://fastview.viewus.co.kr/assets/images/arrow_line.png") no-repeat top center;
        background-size: 100%;

        li {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 auto;
          flex: 0 0 auto;
          width: calc(100% / 6 - 35px);

          &::before {
            display: block;
            content: "";
            border-radius: 10px;
            background-color: #f6f6f6;
            background-position: center center;
            background-size: 60px;
            background-repeat: no-repeat;
            aspect-ratio: 4/3;
          }
        }
      }
    }
  }
`;

const ProcessListLi = styled.li<{ icon: string }>`
  &::before {
    background-image: url(https://fastview.viewus.co.kr/assets/images/${props => props.icon}.svg);
  }

  span {
    display: block;
    margin: 8px 0;
    font-size: 1.3rem;
    color: #56b5cb;
  }
`;

const ThumbnailCell = styled.div`
  display: flex;
  align-items: center;
  img {
    border-radius: 4px;
    width: 100px;
    height: 66px;
    margin-right: 12px;
  }
`;
/**
 * 썸네일, 타이틀
 * @param props [title, thumbnail]
 */
export const GridThumbnailCell = (props: IGrideCell<[string, string]>) => {
  const { platform } = useSelectorEq((state: IState) => ({
    platform: state.statistics.activePpService,
  }));

  return (
    <ThumbnailCell>
      {/* <img
        src={
          props.data[1]
            ? props.data[1]
            : platform === "MSN"
            ? "/icon/new/msn_default_thumbnail.png"
            : "/icon/new/content_default_thumbnail.png"
        }
        alt="썸네일"
      /> */}
      <p>{props.data[0]}</p>
    </ThumbnailCell>
  );
};

/**
 * 서비스 가입이 안되어있을 경우
 * @param props
 * @returns
 */
export function ServiceGuideInfo(props: { tab: string }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const textInfo: { [key: string]: { text: string; title: string; title2: string; subTitle: string; footer: string } } =
    {
      PROVIDER: {
        text: "콘텍스트",
        title: "Context Service",
        title2: "매일 새로운 콘텐츠 공유하고 수익을 창출 하세요!",
        subTitle: "다양한 플랫폼으로 유통된 콘텐츠가 사용자에게 도달함에 따라 발생된 수익을 제공합니다.",
        footer: "뷰어스 가입하시고 콘텐츠 채널을 등록하세요! 검수 후 채널 승인이 완료되면 수익화 할 수 있습니다!",
      },
      MEDIA: {
        text: "음원",
        title: "Soundtrack Service",
        title2: "쇼츠 업로드 할때 음원 사용하고 정산을 받아 보세요!",
        subTitle: "영상 제작하는데 무료 음원 사용하고 사용한 음원의 수익을 제공 합니다.",
        footer: "뷰어스 음원 가입하시고 음원을 사용 하세요! 검수 후 채널 승인이 완료되면 수익화 할 수 있습니다!",
      },
    };

  const footerGroup = [
    { icon: "icon_home", text: "회원가입 및 입점신청" },
    { icon: "icon_search", text: `${props.tab === "PROVIDER" ? "RSS" : "채널"} 등록 후 검토 신청` },
    { icon: "icon_sync", text: `${props.tab === "PROVIDER" ? "콘텐츠 수집 연동" : "음원 등록"}` },
    { icon: "icon_content", text: `${props.tab === "PROVIDER" ? "콘텐츠" : "음원"} 유통` },
    { icon: "icon_data", text: "통계 데이터 제공" },
    { icon: "icon_monitoring", text: "모니터링 및 제휴 성과 관리" },
  ];

  return (
    <ServiceGuideWrapper>
      <ElementGroup.Col>
        <div className="guide-title-conainer">
          <p>{textInfo[props.tab].title}</p>
          <p>{textInfo[props.tab].title2}</p>
          <p className="sub">{textInfo[props.tab].subTitle}</p>
        </div>
        <div className="guide-btn-wrapper">
          <Button
            text={`${textInfo[props.tab].text} 서비스 시작하기`}
            btnType="normal"
            color="secondary"
            btnSize={ButtonSize.MD}
            thin
            onClick={() => {
              // dispatch(rdxSetActiveTab(props.tab as ServiceActiveTab));
              // navigate("/admin/service");

              navigate(`/admin/${props.tab.toLowerCase()}/setting`);
            }}
          />
        </div>
        <div className="guide-footer">
          <p>{textInfo[props.tab].footer}</p>
          <ElementGroup.Row className="guide-step-wrapper">
            <ol className="service-process-list row">
              {footerGroup.map((i, idx) => {
                return (
                  <ProcessListLi key={idx} icon={i.icon}>
                    <span>{`0${idx + 1}`}</span>
                    <p>{i.text}</p>
                  </ProcessListLi>
                );
              })}
            </ol>
          </ElementGroup.Row>
        </div>
      </ElementGroup.Col>
    </ServiceGuideWrapper>
  );
}
export function StatisticsSearchOption(props: { tab: string }): JSX.Element {
  const dispatch = useDispatch();
  const { commit } = useUiAction();
  const { changeValue } = useSetRadio(`${props.tab}_DateOption_radio`);
  const open = useCSVUploadPopup();
  const { role } = useAuth();

  const dateSetAdd = useIniteDateOption();
  useEffect(() => {
    setTimeout(() => {
      changeValue(0, `${props.tab}_DateOption_radio`);
      dateSetAdd(UiType.INPUT_TEXT, `${props.tab}_DateOption_start`, -7);
      dateSetAdd(UiType.INPUT_TEXT, `${props.tab}_DateOption_end`, -1);
      commit();
    }, 500);
  }, [props.tab]);

  return props.tab ? (
    <OptionContainer>
      <DateOptionWrap>
        <ElementGroup.Row style={{ flexWrap: "wrap" }}>
          <UiDateOptionGroup
            id={`${props.tab}_DateOption`}
            list={[
              { id: "7", text: "7일 전" },
              { id: "14", text: "14일 전" },
              { id: "30", text: "30일 전" },
              { id: "90", text: "90일 전" },
              { id: "365", text: "1년 전" },
            ]}
            yesterday
            radioInit={0}
          />
        </ElementGroup.Row>
        <div className="upload-btn-wrap">
          {role === Grade.MASTER && props.tab === "PROVIDER" && (
            <Button
              iconName="Upload"
              iconPosition="before"
              text={`MSN 데이터 등록하기`}
              btnType={"ghost"}
              color={ButtonColor.DARK}
              btnSize={ButtonSize.XS}
              thin
              radius={8}
              onClick={open}
            />
          )}
        </div>
      </DateOptionWrap>
    </OptionContainer>
  ) : (
    <></>
  );
}

/**
 * 통계 > 일별 데이터 분석
 * @returns
 */
export function StatisticsDateGrid(props: { tab: StatisticsTabType }): JSX.Element {
  const { isLoading, date } = useStatisticsDateGrid(props.tab);
  const dateListLoad = useDateGridListLoad(props.tab);

  const contextDateSetting: IGridSetting<IStatisticsDateGridVo>[] = [
    { header: "기간", id: ["date"], element: GridLeftTextCell, width: "60%" },
    {
      header: "조회수",
      id: ["page_view"],
      element: GridLocalStringCell,
      width: "20%",
    },
    {
      header: "예상 정산액",
      id: ["expected_revenue"],
      element: GridLocalStringCell,
      width: "20%",
    },
  ];

  const mediaDateSetting: IGridSetting<IStatisticsDateGridVo>[] = [
    { header: "기간", id: ["date"], element: GridLeftTextCell, width: "55%" },
    {
      header: "조회수",
      id: ["page_view"],
      element: GridLocalStringCell,
      width: "15%",
    },
    {
      header: "프리미엄 조회수",
      id: ["premium_page_view"],
      element: GridLocalStringCell,
      width: "15%",
    },
    {
      header: "예상 정산액",
      id: ["expected_revenue"],
      element: GridLocalStringCell,
      width: "15%",
    },
  ];

  return (
    <ContentsGridContainer isLoading={isLoading}>
      <Title>일별 데이터 분석</Title>

      {isLoading && (
        <LoadingContainer>
          <Spinner size={86} />
        </LoadingContainer>
      )}

      <div className="grid-wrapper">
        <Grid
          container={LeftTableContainer}
          id="StatisticsDate"
          data={date.list}
          setting={props.tab === "MEDIA" ? mediaDateSetting : contextDateSetting}
          emptyInfo={{
            element: GridEmpty,
            props: { text: "조회된 결과가 없습니다." },
          }}
        />
      </div>

      {date.page_info.totalPage! > 1 && (
        <ElementGroup.Row flexContent="center">
          <Pagelable
            current={date.page_info.page}
            total={date.page_info.totalPage}
            change={v => {
              dateListLoad(v);
            }}
          />
        </ElementGroup.Row>
      )}
    </ContentsGridContainer>
  );
}

/**
 * 파트너스가 아닐 경우에만 호출
 * @param props
 * @returns
 */
export function StatisticsContentsGrid(props: { tab: StatisticsTabType }): JSX.Element {
  const { isLoading, tab, content } = useStatisticsContentsGrid(props.tab);
  const contentListLoad = useContentGridListLoad(props.tab);

  const contentSetting: IGridSetting<IStatisticsContentsGridVo>[] = [
    {
      header: "콘텐츠 이름",
      id: ["title", "thumbnail"],
      element: GridThumbnailCell,
      width: props.tab === "PROVIDER" ? "80%" : "55%",
    },
    {
      header: "조회수",
      id: ["page_view"],
      element: GridLocalStringCell,
    },
  ];

  return (
    <>
      <ContentsGridContainer isLoading={isLoading}>
        <Title>콘텐츠 분석</Title>

        {isLoading && (
          <LoadingContainer>
            <Spinner size={86} />
          </LoadingContainer>
        )}

        <div className="grid-wrapper contents-grid-wrap">
          <Grid
            container={LeftTableContainer}
            id="StatisticsContents"
            data={content.list}
            setting={
              tab !== "MEDIA"
                ? contentSetting
                : [
                    ...contentSetting,
                    {
                      header: "프리미엄 조회수",
                      id: ["premium_page_view"],
                      element: GridLocalStringCell,
                    },
                    {
                      header: "예상 정산액",
                      id: ["expected_revenue"],
                      element: GridLocalStringCell,
                    },
                  ]
            }
            emptyInfo={{
              element: GridEmpty,
              props: { text: "조회된 결과가 없습니다." },
            }}
            sortChange={() => {
              // loadList();
            }}
          />
        </div>

        {content.page_info.totalPage! > 1 && (
          <ElementGroup.Row flexContent="center">
            <Pagelable
              current={content.page_info.page}
              total={content.page_info.totalPage}
              change={v => {
                contentListLoad(v);
              }}
            />
          </ElementGroup.Row>
        )}
      </ContentsGridContainer>
    </>
  );
}

export function StatisticsPages(): JSX.Element {
  return <></>;
}

export default StatisticsPages;
